module.exports = __webpack_public_path__ + "static/media/eye-open.9b3c7b85.svg";